import { useState, useEffect } from "react";
import React from "react";
import Sidenav from "../components/Sidenav";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Swal from "sweetalert2";
import config from "../config/config";

const drawerWidth = 240;

export default function Pageauth() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(""); // State for selected user ID
  const [submenu, setSubmenu] = useState([]); // State for submenu data
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [seeAuth, setSeeAuth] = useState(false);
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${config.baseUrl}/Crud/users`);
      setUsers(response.data);
      setFilteredUsers(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchSubmenu = async () => {
    const token = localStorage.getItem("token")?.replace(/['"]/g, "");
    // Replace with actual token
    try {
      const response = await axios.post(
        `${config.baseUrl}/Menu/submenu_forUser?user_id=${selectedUserId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      console.log("submenu:", response.data);
      if (response.status === 200) {
        setSubmenu(response.data);

        console.log("submenu:", response.data);
      } else {
        setSeeAuth(true);
        console.error("Unexpected response:", response.status, response.data);
      }
    } catch (error) {
      setSeeAuth(true);
      console.error("Error fetching submenu", {

        message: error.message,
        response: error.response?.data || null,
      });
    }
  };
  const handleFilter = () => {
    const filtered = users.filter((user) =>
      user.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredUsers(filtered);
    setOpenModal(true); // Open the modal
  };

  const handleUserSelect = (user) => {
    setSearchQuery(user.name); // Set the username in the text field
    setSelectedUserId(user.id); // Set the selected user ID
    setOpenModal(false); // Close the modal

  };

  const handlePageEdit = () => {
    setEditMode(true); // Enable edit mode for all rows
  };

  const handleCheckboxChange = (submenuId, field, value) => {
    setSubmenu((prev) => {
      const updated = prev.map((item) => {
        if (item.submenu_id === submenuId) {
          // Update the specific field or all fields for "Select All"
          if (field === "select_all") {
            return {
              ...item,
              access_view: value,
              access_add: value,
              access_edit: value,
              access_delete: value,
            };
          }
          // Update a specific field
          return {
            ...item,
            [field]: value,
          };
        }
        return item;
      });
      return updated;
    });
  };

  const handleApplyChanges = async () => {
    const token = localStorage.getItem("token")?.replace(/['"]/g, ""); // Fetch token from localStorage

    // Prepare the request body
    const requestBody = {
      user_id: localStorage.getItem("user_id"), // Replace with actual `user_id` dynamically if needed
      assn_user_id: selectedUserId, // Replace dynamically
      access: submenu.map((item) => ({
        submenu_id: item.submenu_id, // Adjust based on your submenu object structure
        access_view: item.access_view ? 1 : 0, // Assuming boolean to int mapping
        access_add: item.access_add ? 1 : 0,
        access_edit: item.access_edit ? 1 : 0,
        access_delete: item.access_delete ? 1 : 0,
      })),
    };

    try {
      const response = await axios.post(
        `${config.baseUrl}/Menu/addAuth`, // API endpoint
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Authorization added successfully:", response.data);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Authorization added successfully!",
          confirmButtonText: "OK",
        }).then(() => {
          fetchSubmenu().then(() => {
            setEditMode(false);
          })
        })
      } else {
        console.error("Unexpected response:", response.status, response.data);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add authorization. Please try again.",
          confirmButtonText: "OK",
        }).then(() => {
          fetchSubmenu().then(() => {
            setEditMode(false);
          })

        })

      }
    } catch (error) {
      console.error("Error applying changes:", {
        message: error.message,
        response: error.response?.data || null,
      });
      alert("An error occurred while applying changes.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <Box />
      <Box sx={{ display: "flex" }}>
        <Sidenav />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Card sx={{ width: "100%", height: 480 }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Page Authorization
              </Typography>
              <hr />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                  gap: 2,
                }}
              >
                <Box sx={{ display: "flex", gap: 1, alignItems: "left" }}>
                  <TextField
                    label="Search by username"
                    variant="outlined"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    size="small"
                  />
                  <Button
                    variant="contained"
                    onClick={handleFilter}
                    size="small"
                  >
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    onClick={fetchSubmenu}
                    size="small"
                    sx={{ visibility: selectedUserId ? "visible" : "hidden" }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>

              {submenu.length > 0 ? (
                <TableContainer
                  component={Paper}
                  sx={{ mt: 2, height: 300, overflow: "auto" }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Pages</TableCell>
                        <TableCell>Select All</TableCell>
                        <TableCell>Access View</TableCell>
                        <TableCell>Access Add</TableCell>
                        <TableCell>Access Edit</TableCell>
                        <TableCell>Access Delete</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {submenu.map((item) => (
                        <TableRow key={item.submenu_id}>
                          <TableCell>{item.submenu}</TableCell>
                          <TableCell>
                            <Checkbox
                              checked={
                                item.access_view === 1 &&
                                item.access_add === 1 &&
                                item.access_edit === 1 &&
                                item.access_delete === 1
                              }
                              disabled={!editMode}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.submenu_id,
                                  "select_all",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item.access_view === 1}
                              disabled={!editMode}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.submenu_id,
                                  "access_view",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item.access_add === 1}
                              disabled={!editMode}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.submenu_id,
                                  "access_add",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item.access_edit === 1}
                              disabled={!editMode}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.submenu_id,
                                  "access_edit",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item.access_delete === 1}
                              disabled={!editMode}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.submenu_id,
                                  "access_delete",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handlePageEdit}
                            >
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    marginTop: 2,
                    color: "text.secondary",
                    textAlign: "center",
                    fontStyle: "italic",
                    visibility: seeAuth ? "visible" : "hidden",
                  }}
                >
                  No records found.
                </Typography>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, visibility: editMode ? "visible" : "hidden" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplyChanges}
                  size="small"

                >
                  Apply Changes
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>
      {/* Modal */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Filtered Users</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Avatar</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Mobile No.</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell>
                      <Avatar alt={user.name} src={user.img} />
                    </TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.role}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.mobile}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleUserSelect(user)} // Pass user to handler
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
      {/* Debugging */}
      {/* <Box sx={{ p: 2 }}>
        <Typography variant="body2">
          <strong>Selected User ID:</strong> {selectedUserId || "None"}
        </Typography>
        <Typography variant="body2">
          <strong>Submenu Data:</strong> {JSON.stringify(submenu, null, 2)}
        </Typography>
      </Box> */}
    </div>
  );
}
